import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';

import moment from 'moment-timezone';

import { InfoboxComponent } from '@core/components-infobox-legacy';
import { I18nService, TranslatePipe } from '@core/i18n-legacy';

@Component({
  selector: 'rt-subscription-future-status-info',
  templateUrl: './subscription-future-status-info.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [InfoboxComponent, TranslatePipe],
})
export class SubscriptionFutureStatusInfoComponent {
  private readonly i18n = inject(I18nService);

  public readonly currentPeriodStart = input<string>();

  public message: string;

  public ngOnInit(): void {
    const date = moment(this.currentPeriodStart()).format('DD MMMM YYYY');

    this.message = this.i18n.translate(
      'app.pricing.billing_page.subscription_future_infobox.message',
      { date: date },
    );
  }
}
